/* All hardcoded Arabic copy for the Mr Ibrahim Farid tenant landing page.
   The hero headline/subheadline are FALLBACKS — admin `landing_headline` /
   `landing_subheadline` settings override them at runtime. */

export const colors = {
	navy: '#163a84',
	navyDeep: '#0e2b64',
	ink: '#0b1c46',
	paper: '#f5f5f5',
	amber: '#ffb81c',
	blue: '#077ef6',
	red: '#fb3640',
	maroon: '#a30225',
	body: '#4a5568',
	muted: '#5a6478',
	line: 'rgba(22,58,132,.14)',
} as const

export const hero = {
	badge: 'لغة إنجليزية · المرحلة الثانوية',
	headlineLine1: 'الإنجليزي مش حفظ…',
	headlineLine2: 'الإنجليزي ',
	headlineHighlight: 'فهم وممارسة',
	headlineEmoji: ' 👌',
	subStrong: 'مستر إبراهيم فريد',
	subBefore: 'مع ',
	subAfter: ' هتتعلم الإنجليزي خطوة بخطوة، بطريقة تخليك تفهم القاعدة، تعرف تستخدم الكلمات، وتحل وأنت فاهم مش حافظ.',
	experienceLine: 'أكتر من 25 سنة خبرة في تدريس اللغة الإنجليزية لطلاب المرحلة الثانوية.',
	ctaPrimary: 'انشاء حساب',
	ctaLogin: 'تسجيل الدخول',
	ctaSecondary: 'اختر الفصل المناسب',
	portraitCaption: 'portrait — Mr. Ibrahim Farid',
	badgeYears: '+25',
	badgeYearsLabel: 'سنة خبرة في التدريس',
} as const

export const stats = {
	title: 'خبرة سنين… وطريقة شرح بتتطور معاك',
	items: [
		{ value: '+25 سنة', text: 'خبرة في تدريس اللغة الإنجليزية', accent: true },
		{ value: 'ثانوي بالكامل', text: 'شرح وتدريب مناسب لطلاب المرحلة الثانوية', accent: false },
		{ value: 'شرح + تطبيق', text: 'مش بنكتفي بشرح القاعدة… لازم تعرف تستخدمها', accent: false },
		{ value: 'متابعة للنظام الحديث', text: 'طريقة تدريس متطورة ومتوافقة مع شكل الامتحانات الجديد', accent: false },
	],
} as const

export const about = {
	kicker: 'ABOUT',
	title: 'مين مستر إبراهيم فريد؟',
	photoCaption: 'photo — teaching / classroom',
	facts: ['كلية الآداب — قسم اللغة الإنجليزية', 'جامعة القاهرة'],
	p2: 'خلال السنين دي، هدفه مكانش إن الطالب يحفظ إجابة أو قاعدة وخلاص، لكن إنه يفهم اللغة نفسها ويعرف يتعامل معاها بشكل صحيح.',
	p3: 'ومع تغيّر نظام الثانوية العامة بداية من دفعة 2021، طوّر مستر إبراهيم فريد طريقة الشرح والتدريب علشان تناسب شكل الأسئلة الجديد، وتساعد الطالب يفكر ويحل بدل ما يعتمد على الحفظ.',
} as const

export const skills = {
	title: 'هنا مش هتذاكر الإنجليزي بنفس الطريقة القديمة',
	p1: 'الإنجليزي مش Grammar لوحدها، ومش Vocabulary تحفظها قبل الامتحان بيوم.',
	p2: 'علشان كده المذاكرة مع مستر إبراهيم فريد بتجمع بين أهم أجزاء المادة بشكل متكامل:',
	cards: [
		{ title: 'Grammar', text: 'تفهم القاعدة ببساطة، وتعرف الفرق بين الأزمنة والاستخدامات المختلفة.', dark: false },
		{ title: 'Vocabulary', text: 'مش مجرد كلمات تحفظها… هتتعلم تستخدمها جوه الجملة والسؤال.', dark: false },
		{ title: 'Reading', text: 'تتعلم إزاي تفهم القطعة وتوصل للإجابة من غير ما تترجم كل كلمة.', dark: false },
		{ title: 'Writing', text: 'تبني جملة صح وتطور مستواك لحد ما تكتب Paragraph بشكل منظم.', dark: false },
		{ title: 'Translation', text: 'تتعلم تفهم المعنى الأول، وبعد كده تختار الترجمة الصح.', dark: false },
		{ title: 'Exam Skills', text: 'تدريب مستمر على شكل الأسئلة وطريقة التفكير المطلوبة في الامتحان.', dark: true },
	],
} as const

export const pains = {
	titleStart: 'لو الإنجليزي بالنسبالك شوية قواعد وكلمات متلخبطة… ',
	titleHighlight: 'إحنا هنرتبهالك',
	titleEmoji: ' 😅',
	rows: [
		'ممكن تكون عارف القاعدة بس مش عارف تحل عليها.',
		'أو حافظ كلمات كتير، بس أول ما تيجي في جملة متعرفش تختار الصح.',
		'أو أكبر مشكلة عندك هي الـReading والقطعة الطويلة.',
	],
	rowMuted: 'وده طبيعي لما كل جزء في المادة يتذاكر لوحده.',
	resolution: 'هنا هنربطلك أجزاء اللغة ببعض، بحيث كل حاجة تتعلمها تعرف تستخدمها فعليًا في الحل.',
} as const

export const method = {
	kicker: 'METHOD',
	title: 'هنمشي معاك إزاي؟',
	steps: [
		{ num: '01', title: 'نفهم', text: 'نبدأ الفكرة من الأساس ونشرحها بطريقة واضحة وبسيطة.' },
		{ num: '02', title: 'نطبق', text: 'نحل أمثلة وأسئلة مختلفة لحد ما الفكرة تثبت.' },
		{ num: '03', title: 'نتدرب', text: 'تدخل على تدريبات واختبارات تعرفك مستواك الحقيقي.' },
		{ num: '04', title: 'نراجع', text: 'نرجع للنقط المهمة والأخطاء المتكررة قبل ما تتراكم عليك.' },
	],
	goalTitle: 'الهدف؟',
	goalIntro: 'إنك لما تقابل السؤال في الامتحان تقول:',
	goalQuote: '«أنا عارف هو عايز مني إيه.»',
	goalNot: 'مش:',
	goalStruck: '«أنا فاكر إني شوفت حاجة شبه دي قبل كده!»',
	goalStruckEmoji: ' 😅',
} as const

export const classroomsSection = {
	title: 'اختر فصلك',
	titleEmoji: ' 🚀',
	sub: 'كل فصل ليه خطة شرح وتدريب مناسبة ليه ومتابعته الخاصة بيه.',
} as const

export const freeTrial = {
	title: 'مش لازم تصدق الكلام… جرّب بنفسك',
	titleEmoji: ' 👀',
	p1: 'قبل ما تشترك، تقدر تشوف جزء من المحتوى وتجرب طريقة شرح مستر إبراهيم فريد بنفسك.',
	p2: 'شوف الشرح، جرّب الأسئلة، وبعدها قرر إذا كانت الطريقة مناسبة ليك.',
	ctaPrimary: 'جرّب درس مجاني',
	/* the free sample lesson lives in the 1st-secondary classroom */
	freeLessonPath: '/classroom/FM-27-1st-EN-ON/courses/1',
	ctaSecondary: 'شوف المحتوى المتاح',
	videoCaption: 'sample lesson video',
	groupBefore: 'ولو عايز تتابع كل جديد… ',
	groupCta: 'انضم لجروب الفيسبوك',
	groupOr: ' أو ',
	channelCta: 'قناة الواتساب',
} as const

export const modernExam = {
	kicker: 'NEW SYSTEM',
	title: 'الثانوية اتغيرت… وطريقة مذاكرتك لازم تتغير',
	p1: 'من وقت تغيير نظام الثانوية العامة، الأسئلة بقت تعتمد أكتر على الفهم والتطبيق والربط بين المعلومات.',
	p2: 'وعلشان كده، طريقة الشرح والتدريب اتطورت هي كمان.',
	p3: 'مع مستر إبراهيم فريد، التركيز مش على إنك تحفظ شكل سؤال معين، لكن إنك تفهم الفكرة كويس بحيث تعرف تتعامل معاها مهما اتغير شكل السؤال.',
	chain: [
		{ label: 'نفهم', variant: 'default' },
		{ label: 'نحل', variant: 'default' },
		{ label: 'نغلط', variant: 'red' },
		{ label: 'نصحح', variant: 'default' },
		{ label: 'نتحسن', variant: 'amber' },
	],
	closing: 'وده اللي بيخلي المذاكرة ليها نتيجة حقيقية.',
} as const

export const experience = {
	title: 'مذاكرتك كلها في مكان واحد',
	p1: 'بدل ما الفيديو في مكان، والواجب في مكان، والامتحان مش عارف كان فين…',
	p2: 'هتلاقي كل حاجة مترتبة قدامك:',
	pills: ['المحاضرات', 'التدريبات', 'الامتحانات', 'الملفات والمذكرات', 'الواجبات', 'المراجعات'],
	pillAccent: 'متابعة تقدمك',
	closing: 'إنت عليك تفتح وتبدأ… والباقي مترتبلك.',
	shotCaption: 'screenshot — student dashboard',
} as const

export const philosophy = {
	title: 'الهدف واضح … أعلى درجة… ومستوى أقوى',
	titleEmoji: ' 🎯',
	p1: 'مش بنشرح علشان تعدّي الامتحان وبس،',
	p2: 'بنشتغل معاك علشان تنافس على الدرجة النهائية وإنت فاهم وواثق في كل خطوة.',
	cards: [
		{ text: 'بتفهم أكتر.', dark: false },
		{ text: 'بتحل أسرع.', dark: false },
		{ text: 'بتكتب أحسن.', dark: false },
		{ text: 'وعندك ثقة أكبر في الإنجليزي.', dark: true },
	],
	closing: 'والنتيجة؟ تدخل الامتحان جاهز لأعلى درجة ممكنة.',
} as const

export const faq = {
	kicker: 'FAQ',
	title: 'عندك سؤال؟',
	items: [
		{ q: 'المحتوى مناسب لمين؟', a: 'لطلاب المرحلة الثانوية، سواء محتاج تأسيس، شرح المنهج، تدريب، أو مراجعة.' },
		{ q: 'هل الشرح أونلاين بالكامل؟', a: 'أيوه، تقدر تتابع المحتوى المتاح ليك أونلاين وتذاكر في الوقت المناسب ليك.' },
		{ q: 'لو مستوايا ضعيف في الإنجليزي أقدر أبدأ؟', a: 'أكيد. في محتوى بيبدأ من الأساسيات وبيساعدك تبني مستواك خطوة بخطوة.' },
		{ q: 'هل فيه امتحانات وتدريبات؟', a: 'أيوه، التدريب جزء أساسي من طريقة المذاكرة، لأن الفهم لوحده من غير تطبيق مش كفاية.' },
		{ q: 'أقدر أجرب قبل الاشتراك؟', a: 'هتلاقي محتوى مجاني وتجريبي تقدر تشوف من خلاله طريقة الشرح الأول.' },
	],
} as const

export const finalCta = {
	title: 'جاهز تخلي الإنجليزي أوضح وأسهل؟',
	titleEmoji: ' 🔥',
	pStrong: 'مستر إبراهيم فريد',
	pBefore: 'ابدأ مع ',
	pAfter: '، واختار الصف أو الكورس المناسب ليك.',
	p2: 'مش مطلوب منك تبقى شاطر في الإنجليزي من أول يوم.',
	p3: 'المطلوب بس إنك تبدأ.',
	cta: 'ابدأ دلوقتي',
} as const

export const stickyBar = {
	primary: 'انشاء حساب',
	secondary: 'تسجيل الدخول',
} as const

/* TEMPORARY — the September 2026 term-package promotion. Revert the commit
   that added this once the campaign is over.

   `start` and `end` are absolute instants with an explicit offset, not local
   dates: Egypt is UTC+3 for this window but drops to UTC+2 on 30 October, so a
   bare "2026-09-03T00:00" would mean different moments either side of that.

   The banner hides itself outside the window, so it appears and disappears
   without a deploy. End is 17 Sep 00:00, which makes Wednesday 16 Sep the last
   full day it is visible. */
export const promo = {
	start: '2026-09-03T00:00:00+03:00',
	end: '2026-09-17T00:00:00+03:00',
	badge: 'عرض الأذكياء',
	headline: 'خصم 25% على باكدج الترم كامل',
	sub: 'ابدأ أولى ثانوي صح من أول يوم — العرض لفترة محدودة',
	cta: 'اشترك دلوقتي',
	/* relative so react-router navigates in-app; an absolute URL to our own
	   domain would trigger a full page reload and throw away app state */
	path: '/classroom/FM-27-1st-EN-ON/courses/3',
	countdownLabel: 'ينتهي خلال',
	units: { days: 'يوم', hours: 'ساعة', minutes: 'دقيقة', seconds: 'ثانية' },
} as const
